// @owners { team: patients-team }
import { useCallback } from 'react';
// eslint-disable-next-line import/no-deprecated
import { fetchNextAvailableDates } from '~shared/actions/nextAvailableDates';
import { usePrescriptionsInCart } from '~shared/features/cart/hooks/usePrescriptionsInCart';
import { useNextAvailableDateAddressId } from '~shared/features/next-available-date/hooks/useNextAvailableDateAddressId';
import { useDispatchShared } from '~shared/store';

export const useFetchNextAvailableDatesForCart = () => {
  const dispatch = useDispatchShared();
  const { prescriptionIDs } = usePrescriptionsInCart();
  const addressID = useNextAvailableDateAddressId();

  return useCallback(
    async (options?: { unbundledPrescriptionIDs?: number[]; context?: string }) => {
      const unbundledPrescriptionIDs = options?.unbundledPrescriptionIDs || [];
      // on app start do not fetch next available dates when no prescriptions are in the cart
      if (unbundledPrescriptionIDs.length === 0 && prescriptionIDs.length === 0) {
        return;
      }

      await dispatch(
        // eslint-disable-next-line import/no-deprecated
        fetchNextAvailableDates({
          unbundledPrescriptionIDs,
          bundledPrescriptionIDs: prescriptionIDs,
          addressID,
        }),
      );
    },
    [addressID, dispatch, prescriptionIDs],
  );
};
